<template>
    <div>
        <div class="row">
            <div v-for="(widget, index) in widgets" :key="index" class="col-md-4 col-12 p-3">
                <div class="card border-left-primary shadow h-100 py-2">
                    <div class="card-body">
                        <div class="row no-gutters align-items-center">
                            <div class="col mr-2">
                                <h5>{{widget.name}}</h5>
                            </div>
                            <div class="col-auto">
                                <img class="dashboard-widget-image" :title="widget.name" :src="widget.icon"/>
                            </div>
                        </div>
                        <router-link :to="widget.route" class="btn btn-primary">Manage</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                
            }
        },
        computed : {
            widgets() {
                return [
                    {
                        name: 'Categories Management',
                        route: '/admin/categories',
                        icon: '/assets/images/category-management-icon.png'
                    },
                    {
                        name: 'Doctors Management',
                        route: '/admin/doctors',
                        icon: '/assets/images/doctor-management-icon.png'
                    },
                    {
                        name: 'Languages Management',
                        route: '/admin/languages',
                        icon: '/assets/images/language-management-icon.png'
                    }
                ]
            }
        },
        methods: {

        },
        mounted: function() {

        }
    }
</script>
<style lang="scss" scoped>
    .dashboard-widget-image {
        height: 64px;
    }
</style>